// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Result_wrapper__1O1_v","list":"Result_list__3dxAt"};